<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function () {
  var PRODUCT_CACHE = new Map();
  var INFLIGHT = new Map();

  function getHandleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);

    if (PRODUCT_CACHE.has(handle)) return Promise.resolve(PRODUCT_CACHE.get(handle));
    if (INFLIGHT.has(handle)) return INFLIGHT.get(handle);

    var p = fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (product) PRODUCT_CACHE.set(handle, product);
        return product;
      })
      .catch(function () { return null; })
      .finally(function () { INFLIGHT.delete(handle); });

    INFLIGHT.set(handle, p);
    return p;
  }

  function setButtonToPreorder(scopeEl) {
    // Your screenshot hook
    var btn = scopeEl.querySelector('form[action^="/cart/add"] [data-btn-addtocart]');
    if (!btn) return;

    btn.textContent = "Pre-order";
    btn.setAttribute("aria-label", "Pre-order");
  }

  function processLink(linkEl) {
    if (!linkEl || linkEl.__preorder_checked) return;
    linkEl.__preorder_checked = true;

    var handle = getHandleFromHref(linkEl.getAttribute("href"));
    if (!handle) return;

    // Find a reasonable "card" container that contains both the link and the button
    // Try a few common wrappers; fall back to parentElement
    var card =
      linkEl.closest(".card") ||
      linkEl.closest(".product-card") ||
      linkEl.closest(".grid__item") ||
      linkEl.parentElement;

    if (!card) return;

    fetchProduct(handle).then(function (product) {
      if (!product || !Array.isArray(product.tags)) return;

      var tags = product.tags.map(function (t) { return String(t).toLowerCase(); });
      if (tags.includes("preorder")) {
        setButtonToPreorder(card);
      }
    });
  }

  function run() {
    document.querySelectorAll('a.card-link[href^="/products/"]').forEach(processLink);
  }

  document.addEventListener("DOMContentLoaded", run);
  setTimeout(run, 250);

  // For filtering / infinite scroll / ajax-loaded cards
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();

